export const PROJECT_FILE_EXTENSION = '.mpbproj';
export const LEGACY_PROJECT_FILE_EXTENSION = '.mbproj';
export const PROJECT_FILE_MAGIC = 'MICROPINOUTS_PROJECT_BUILDER_FILE_V1';
export const PROJECT_FILE_ACCEPT = '.mpbproj,.mbproj,.json,application/json,text/plain';

const encodeUtf8ToBase64 = (value) => {
  const source = String(value || '');

  if (typeof btoa !== 'function') {
    throw new Error('Base64 encoding is unavailable in this browser.');
  }

  if (typeof TextEncoder !== 'undefined') {
    const bytes = new TextEncoder().encode(source);
    let binary = '';

    for (let index = 0; index < bytes.length; index += 0x8000) {
      binary += String.fromCharCode(...bytes.subarray(index, index + 0x8000));
    }

    return btoa(binary);
  }

  return btoa(unescape(encodeURIComponent(source)));
};

const decodeBase64ToUtf8 = (value) => {
  if (typeof atob !== 'function') {
    throw new Error('Base64 decoding is unavailable in this browser.');
  }

  const binary = atob(String(value || '').trim());

  if (typeof TextDecoder !== 'undefined') {
    const bytes = new Uint8Array(binary.length);

    for (let index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }

    return new TextDecoder().decode(bytes);
  }

  return decodeURIComponent(escape(binary));
};

export const normalizeProjectSimulationCode = (source) => (
  String(source || '').replace(/\r\n?/g, '\n')
);

export const getProjectStoredSimulationCode = (project) => (
  normalizeProjectSimulationCode(
    project?.simulation?.code || project?.simulationCode || ''
  )
);

export const sanitizeProjectExportFileName = (
  value,
  fallbackBaseName = 'builder-circuit'
) => {
  const normalizeBaseName = (baseName) => String(baseName || '')
    .normalize('NFKD')
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const rawValue = String(value || '').trim();
  const fallback = normalizeBaseName(fallbackBaseName) || 'builder-circuit';
  const withoutExtension = rawValue.replace(/\.(json|mbproj|mpbproj)$/i, '');
  const baseName = normalizeBaseName(withoutExtension) || fallback;

  return `${baseName}${PROJECT_FILE_EXTENSION}`;
};

export const getProjectImportFallbackName = (fileName) => {
  const normalizedName = String(fileName || '')
    .replace(/\.[^.]+$/u, '')
    .trim();

  return normalizedName || 'Imported Project';
};

export const encodeProjectFileContents = (project) => {
  const encodedPayload = encodeUtf8ToBase64(JSON.stringify(project))
    .split('')
    .reverse()
    .join('');

  return `${PROJECT_FILE_MAGIC}\n${encodedPayload}`;
};

export const decodeProjectFileContents = (rawContents) => {
  const normalizedContents = String(rawContents || '').trim();

  if (!normalizedContents) {
    return null;
  }

  if (normalizedContents.startsWith(PROJECT_FILE_MAGIC)) {
    const encodedPayload = normalizedContents.slice(PROJECT_FILE_MAGIC.length).trim();
    const decodedPayload = decodeBase64ToUtf8(
      encodedPayload
        .split('')
        .reverse()
        .join('')
    );

    return JSON.parse(decodedPayload);
  }

  return JSON.parse(normalizedContents);
};
